import { render } from "./RechargeSuccessView.vue?vue&type=template&id=c3714634"
import script from "./RechargeSuccessView.vue?vue&type=script&lang=js"
export * from "./RechargeSuccessView.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__